import React from "react"
import { Card, Spin, Typography, Empty } from "antd"
import { DashboardOutlined } from "@ant-design/icons"

const { Title } = Typography

const MetabaseSection = ({ iframeUrl, loading = false, height = "800px" }) => {
  return (
    <Card
      title={
        <span>
          <DashboardOutlined style={{ marginLeft: "8px" }} />
          <Title level={5} style={{ display: "inline", margin: 0 }}>
            داشبورد تحلیلی
          </Title>
        </span>
      }
      variant="outlined"
      style={{
        borderRadius: "8px",
        height: "100%",
      }}
      styles={{ body: { padding: 0 } }}

    >
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: height,
          }}
        >
          <Spin size="large" tip="در حال بارگذاری داشبورد..." />
        </div>
      ) : iframeUrl ? (
        <iframe
          src={iframeUrl}
          title="Metabase Dashboard"
          width="100%"
          height={height}
          style={{ border: "none", display: "block" }}
        />
      ) : (
        <div style={{ padding: "40px", textAlign: "center" }}>
          <Empty description="داشبورد در دسترس نیست" />
        </div>
      )}
    </Card>
  )
}

export default MetabaseSection
